import { MatTableDataSource } from '@angular/material/table';
import { PointOfInterest } from '../categories/categories.model';

export class PointsOfInterestDataSource extends MatTableDataSource<PointOfInterest> {

  constructor(data: PointOfInterest[]) {
    super(data)
  }

  disconnect(): void {//this is a method
  }

}

